import React from "react";
import { faAnglesLeft, faAnglesRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const PaginationOverview = ({ totalNbOfPage, selectedPage, setSelectedPage, GetOverviewOrders, dateFrom, dateTo, status, orderID, type, clientFullName }) => {
    const totalPages = totalNbOfPage;

    // Generate page numbers dynamically based on the current page and total pages
    const generatePageNumbers = () => {
        const pageNumbers = [];
        let numTabs = 5;

        if (totalPages < numTabs) {
            numTabs = totalPages;
        }

        // Handle pagination for first few pages
        if (selectedPage <= Math.floor(numTabs / 2) + 1) {
            for (let i = 1; i <= numTabs; i++) {
                pageNumbers.push(i);
            }
        } 
        // Handle pagination for last few pages
        else if (selectedPage >= totalPages - Math.floor(numTabs / 2)) {
            for (let i = totalPages - numTabs + 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } 
        // Handle pagination for middle pages
        else {
            for (let i = selectedPage - Math.floor(numTabs / 2); i <= selectedPage + Math.floor(numTabs / 2); i++) {
                pageNumbers.push(i);
            }
        }
        return pageNumbers;
    };

    // Handle previous page click
    const handlePreviousPage = () => {
        if (selectedPage > 1) {
            const newPage = selectedPage - 1;
            setSelectedPage(newPage);
            // Call GetOverviewOrders with the updated page and other parameters
            GetOverviewOrders(newPage, dateFrom, dateTo, status, orderID, type, clientFullName);
        }
    };

    // Handle next page click
    const handleNextPage = () => {
        if (selectedPage < totalPages) {
            const newPage = selectedPage + 1;
            setSelectedPage(newPage);
            // Call GetOverviewOrders with the updated page and other parameters
            GetOverviewOrders(newPage, dateFrom, dateTo, status, orderID, type, clientFullName);
        }
    };

    return (
        <>
            {totalPages !== 0 && (
                <div id="pagination">
                    {/* Previous button */}
                    <button
                        className="btn me-3"
                        disabled={selectedPage === 1}
                        onClick={handlePreviousPage}
                    >
                        <FontAwesomeIcon icon={faAnglesLeft} />
                    </button>

                    {/* Page number buttons */}
                    {generatePageNumbers().map((page) => (
                        <button
                            key={page}
                            className={`btn ${page === selectedPage ? 'active' : ''}`}
                            onClick={() => {
                                setSelectedPage(page);
                                // Call GetOverviewOrders with the selected page and other parameters
                                GetOverviewOrders(page, dateFrom, dateTo, status, orderID, type, clientFullName);
                            }}
                        >
                            {page < 10 ? `0${page}` : page}
                        </button>
                    ))}

                    {/* Next button */}
                    <button
                        className="btn ms-4"
                        disabled={selectedPage === totalPages}
                        onClick={handleNextPage}
                    >
                        <FontAwesomeIcon icon={faAnglesRight} />
                    </button>
                </div>
            )}
        </>
    );
};

export default PaginationOverview;
